/* Docs & notes: word processor with tracked changes, comments, live co-editing, AI suggestions, templates, save
   points and DOCX/Markdown/HTML/PDF conversion; Markdown notes with wiki links and backlinks.
   API: api/src/modules/docs/README.md. */
import { lazy } from 'react';
import { FileText } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'docs',
  title: 'Docs & notes',
  short: 'Docs',
  icon: FileText,
  group: 'Apps',
  route: '/docs',
  order: 20,
  rail: true,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'new', title: 'New document', to: '/docs?new=1', keywords: ['doc', 'write', 'word'] },
    { id: 'template', title: 'New document from a template', to: '/docs?template=1', keywords: ['memo', 'report', 'mail merge'] },
    { id: 'import', title: 'Import a Word or Markdown file', to: '/docs?import=1', keywords: ['docx', 'upload', 'convert'] },
    { id: 'daily', title: "Today's note", to: '/docs?daily=1', keywords: ['daily', 'journal', 'notes'] },
    { id: 'notes', title: 'Notes', to: '/docs/notes', keywords: ['wiki', 'backlinks', 'markdown'] },
  ],
  capabilities: ['OFFICE-01', 'OFFICE-09', 'OFFICE-10', 'COLLAB-02'],
});
